import { FC, useMemo } from 'react';

import numeral from 'numeral';
import { AvailableCurrencies, CURRENCY_SYMBOLS, getClicksByBudget } from 'utils/clickme';
import { RECOMMENDED_TOTAL_BUDGET } from 'utils/constants/campaign';
import { DASH, NON_BREAKING_SPACE } from 'utils/constants/common';

import { Card, HSpacingContainer, Text, VSpacing } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import withErrorBoundary from 'components/common/ErrorBoundary/withErrorBoundary';
import { CardCommonContent } from 'components/CpcFlexibleCreate/SourcesAndBudgetsSidebar/CardCommonContent/CardCommonContent';

import { useSelector } from 'store/utils';

const TrlKeys = {
    recommended: 'AdCreate.AdForm.ClicksForecastCard.recommended',
    forecast: 'AdCreate.AdForm.ClicksForecastCard.forecast',
    clicks: 'AdCreate.AdForm.ClicksForecastCard.clicks',
    expenses: 'AdCreate.AdForm.ClicksForecastCard.expenses',
};

const ClicksForecastCardComponent: FC = () => {
    const { pricePerClick, adTotalBudget, adTotalBudgetNoLimits } = useSelector((state) => state.createCampaign);

    const trl = useTrls();

    const countClicks = useMemo(
        () => numeral(getClicksByBudget(adTotalBudget || RECOMMENDED_TOTAL_BUDGET, pricePerClick)).format('0,0'),
        [adTotalBudget, pricePerClick]
    );

    const totalBudget = useMemo(
        () => numeral(adTotalBudget || RECOMMENDED_TOTAL_BUDGET).format('0,0'),
        [adTotalBudget]
    );

    return (
        <CardCommonContent title={trl(TrlKeys[adTotalBudget ? 'forecast' : 'recommended'])} style="secondary">
            <VSpacing default={16} />
            <HSpacingContainer default={0}>
                <Card stretched style="secondary">
                    <Text typography="label-2-regular" style="secondary">
                        {trl(TrlKeys.clicks)}
                    </Text>
                    <VSpacing default={6} />
                    <Text maxLines={1} typography="title-4-semibold">
                        {adTotalBudgetNoLimits ? DASH : countClicks}
                    </Text>
                </Card>
                <Card stretched style="secondary">
                    <Text typography="label-2-regular" style="secondary">
                        {trl(TrlKeys.expenses)}
                    </Text>
                    <VSpacing default={6} />
                    <Text maxLines={1} typography="title-4-semibold">
                        {adTotalBudgetNoLimits ? (
                            DASH
                        ) : (
                            <>
                                {totalBudget}
                                {NON_BREAKING_SPACE}
                                {CURRENCY_SYMBOLS[AvailableCurrencies.RUR]}
                            </>
                        )}
                    </Text>
                </Card>
            </HSpacingContainer>
        </CardCommonContent>
    );
};

const ClicksForecastCard = withErrorBoundary(ClicksForecastCardComponent);
export { ClicksForecastCard };
